import { XRewardConfig } from "../data/XRewardConfig";

export class XShareService {
  /** Generate and open X (Twitter) share intent URL */
  static share(score: number): void {
    const text = XRewardConfig.shareTextTemplate.replace(
      "{score}",
      String(score)
    );
    const hashtags = XRewardConfig.hashtags.join(",");

    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      text
    )}&hashtags=${encodeURIComponent(hashtags)}`;

    window.open(url, "_blank", "noopener,noreferrer");
  }
}
